import { useState } from 'react';
import { useIntl } from 'react-intl';

//MUI
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

interface Props {
  /**
   * id dịch cho intl.formatMessage
   */
  tabLabels: string[];

  /**
   * View thực tế của mỗi tab
   */
  tabContents: JSX.Element[];
}

/**
 * Hiển thị các tab với nội dung tương ứng.
 */
const TabsView = (props: Props) => {
  const { tabLabels, tabContents } = props;

  const [currentTab, setCurrentTab] = useState<string>('0');

  const intl = useIntl();

  if (tabLabels.length !== tabContents.length) return <></>;

  const handleChangeTab = (_: React.SyntheticEvent, tabIndex: number) => {
    setCurrentTab(tabIndex.toString());
  };

  return (
    <TabContext value={currentTab}>
      <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <TabList
          onChange={handleChangeTab}
          aria-label="account tabs"
          selectionFollowsFocus
          variant="scrollable"
          sx={{ px: { mobile: 1, tablet: 2 }, borderBottom: 1, borderColor: 'divider' }}
        >
          {tabLabels.map((label, index) => (
            <Tab key={label} label={intl.formatMessage({ id: label })} value={index.toString()} />
          ))}
        </TabList>
        {tabContents.map((_, index) => (
          <TabPanel key={index} value={index.toString()} sx={{ p: { mobile: 2, tablet: 3 } }}>
            {tabContents[index]}
          </TabPanel>
        ))}
      </Paper>
    </TabContext>
  );
};

export default TabsView;
